module.exports = __webpack_public_path__ + "img/non-banking.44119011.svg";